export default "__VITE_ASSET__Dr2aVM$S__"